/**
 * @generated SignedSource<<30c3eb908ef17641f3ed2e752d805c47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZoomSettings_user$data = {
  readonly id: string;
  readonly " $fragmentType": "ZoomSettings_user";
};
export type ZoomSettings_user$key = {
  readonly " $data"?: ZoomSettings_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ZoomSettings_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ZoomSettings_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e45b01d33edba87a823d5aed557db305";

export default node;
